import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccountService } from '../../app/services/account.service';
import { Router } from '@angular/router';

import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { Observable, Subscription } from 'rxjs';
@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];
  interval;
  constructor(private accountService: AccountService, private router: Router) {}

  async ngOnInit() {
    this.checkOnlineStatus();
    await this.checkNetwok();
    this.refreshNetwork();
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
  refreshNetwork() {
    this.interval = setInterval(() => {
      this.checkNetwok();
    }, 2 * 1000);
  }
  async checkNetwok() {
    try {
      await this.accountService.requestCaptcha();
      this.router.navigate(['/']);
    } catch (e) {}
  }
  checkOnlineStatus = () => {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');
    this.subscriptions.push(this.onlineEvent.subscribe(() => console.log('Connected!')));
    this.offlineEvent.subscribe(() => console.log('Check Connectivity!'));
  };
}
